import React        from 'react';
import { Link }     from 'react-router-dom';
import LocaleString from '../../shared/locale-string';

import './footer.scss';

const Footer = props => {
    const { authenticated, participantRules, privacyNotice: { version } } = props;
    const now = new Date();
    const year = now.getFullYear();

    return (
        <footer className="footer">
            <div className="content-container">
                <nav role="navigation">
                    <ul className="footer-nav">
                        {
                            authenticated && participantRules.length !== 0 &&
                            <li>
                                <Link to="/rules" className="footer-link">
                                    <LocaleString code="footer.link.rulesLabel"/>
                                </Link>
                            </li>
                        }

                        {
                            authenticated &&
                            <li>
                                <Link to="/contact" className="footer-link">
                                    <LocaleString code="footer.link.contactLabel" />
                                </Link>
                            </li>
                        }

                        {
                            authenticated &&
                            <li>
                                <Link to="/faqs" className="footer-link">
                                    <LocaleString code="footer.link.faqsLabel" />
                                </Link>
                            </li>
                        }

                        <li>
                            <Link to="/privacy-shield" className="footer-link">
                                <LocaleString code="footer.link.privacyPolicyLabel" />
                            </Link>
                        </li>

                        {
                            authenticated && version > 0 &&
                            <li>
                                <Link to="/privacy-notice" className="footer-link">
                                    <LocaleString code="privacy.notice.linkLabel" />
                                </Link>
                            </li>
                        }

                    </ul>
                </nav>
                <p className="copyright">
                    <LocaleString code="common.copyrightLabel" replaceOptions={ { year } } />
                </p>
            </div>
        </footer>
    );
};

export default Footer;
